module.exports = __webpack_public_path__ + "static/media/exams.dfc017ae.svg";